<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat)
            breadcrumb(back='page1-5')
              | Estás en: Elige tu Crédito Hipotecario / ¿Estoy listo para cursar esta lección?
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B ') PREGUNTA 5 DE 5
            v-card-text.titulo24Reg.text-center.mx-2.px-0
              | El Interés es uno de los elementos primordiales a considerar para contratar cualquier tipo de crédito. Es importante que tengas conocimiento alrededor de esta variable financiera.
            v-card-text.parrafoDestacadoB.text-center  Dada la siguiente afirmación, selecciona la respuesta que consideres correcta.
            v-card.questionCard(justify-center, flat)
              v-card-text.titulo18Book.text-center
                | El interés es el porcentaje que te cobra el banco para asegurar que se le pague.
              v-layout.py-0.my-0(row, justify-center)
                v-flex(xs8, sm6, md4, offset-xs1, justify-center)
                  v-radio-group(v-model='respuesta ', row)
                    div(v-if='sent && (respuesta==true) ')
                      v-icon(size='15px', color='red ') fas fa-times
                    v-radio.pt-0.px-4(color='primary ', :label='`Cierto` ', :value='true ')
                    div(v-if='sent && (respuesta==false) ')
                      v-icon(size='15px', color='green') fas fa-check
                    v-radio.pt-0.px-4(color='primary ', :label='`Falso` ', :value='false ')
            v-layout(row, justify-center)
              v-flex
                div(v-if='sent==false ')
                  v-btn.btn(color='secondary ', v-bind:class='responseIsNone ', :disabled="respuesta=='none' ", @click='sendResult() ')
                    | Enviar
                div(v-if='sent ')
                  v-btn.btn(color='accent ', style='z-index:2', @click.prevent='dialog=true ')
                    | Ver Retroalimentación
                  v-dialog(v-model='dialog ', persistent, max-width='930px ')
                    v-layout(row, justify-center)
                      v-flex(text-xs-center)
                        v-card
                          div(v-if='sent && (respuesta==false) ')
                            v-layout(v-if='dialog ')
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoArriba.png ')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | ¡Bien!
                            v-card.questionCard(flat)
                              v-card-text.dialog_text
                                p.text-sm-left.px-5
                                  b
                                    | Es falso que el interés sea el porcentaje que te cobra el banco para asegurar que se le pague.
                                p.text-sm-left.px-5
                                  | En realidad, el interés es el porcentaje que el banco te cobra por financiar tu deuda.
                                p.text-sm-left.px-5 
                                  | Si quieres saber más sobre el concepto de interés, 
                                  a(href="https://www.bancomer.com/personas/educacion-financiera/tasa-de-interes-vs-tiempo-para-pagar.html" target="_blank") consulta este enlace 
                          
                          div(v-if='sent && (respuesta==true) ')
                            v-layout(v-if='dialog ')
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoStop.png ')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | Tu respuesta puede mejorar!
                            v-card.questionCard(flat)
                              v-card-text.dialog_text
                                p.text-sm-left.px-5
                                  | De hecho, el banco al otorgarte cualquier tipo de crédito está confiando en que le vas a pagar, y por lo tanto es falso que el interés sea el porcentaje que te cobra el banco para asegurar que se le pague.
                                p.text-sm-left.px-5
                                  | En realidad, el interés es el porcentaje que el banco te cobra por financiar tu deuda.
                                p.text-sm-left.px-5 
                                  | Si quieres saber más sobre el concepto de interés, 
                                  a(href="https://www.bancomer.com/personas/educacion-financiera/tasa-de-interes-vs-tiempo-para-pagar.html" target="_blank") consulta este enlace 
                          
                          v-btn.btn.dialog_btn(color='accent ', @click.prevent="nextPage( 'page1-7') ")
                            | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  data() {
    return {
      dialog: false,
      correcta: false,
      respuesta: 'none',
      sent: false,
      resultado: 0,
    }
  },
  methods: {
    sendResult() {
      if (this.correcta == this.respuesta) {
        this.resultado = 1;
      }
      this.sent = true;
      eventBus.$emit('send_result', this.resultado);
      eventBus.$emit('suspend_data', this.respuesta);
    },
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    }
  },
  created() {
    if ('suspend_data'in this.$parent) {
      if (this.$parent.currentPage in this.$parent.suspend_data) {
        this.respuesta = this.$parent.suspend_data[this.$parent.currentPage];
        this.sendResult();
      }
    }
  },
  computed: {
    responseIsNone() {
      return {
        'btn-primary': this.respuesta != 'none',
        'btn-secondary': this.respuesta == 'none'
      }
    }
  }
};
</script>
